import type { StatusBadgeProps } from "@/components/ds/StatusBadge";
type Tone = NonNullable<StatusBadgeProps["tone"]>;

export const STATUS_META: Record<string, { label: string; tone: Tone; bar: string }> = {
  pending: { label: "Pending", tone: "amber", bar: "border-l-amber-400" },
  confirmed: { label: "Confirmed", tone: "blue", bar: "border-l-blue-500" },
  completed: { label: "Completed", tone: "green", bar: "border-l-emerald-500" },
  cancelled: { label: "Cancelled", tone: "red", bar: "border-l-red-400" },
  no_show: { label: "No-show", tone: "red", bar: "border-l-red-500" },
  rescheduled: { label: "Rescheduled", tone: "slate", bar: "border-l-slate-300" },
};

export const statusMeta = (s: string) => STATUS_META[s] ?? { label: s, tone: "slate" as Tone, bar: "border-l-slate-300" };

export const WEEKDAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
export const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

// --- Date helpers (all operate in the browser's local tz for grid layout) ---
export function startOfWeek(d: Date): Date {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  x.setDate(x.getDate() - x.getDay());
  return x;
}
export function addDays(d: Date, n: number): Date {
  const x = new Date(d);
  x.setDate(x.getDate() + n);
  return x;
}
export function startOfDay(d: Date): Date {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  return x;
}
export function endOfDay(d: Date): Date {
  const x = new Date(d);
  x.setHours(23, 59, 59, 999);
  return x;
}
export function sameDay(a: Date, b: Date): boolean {
  return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
}
export function isoDate(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}
export function fmtTime(iso: string): string {
  return new Date(iso).toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" });
}
export function fmtDateTime(iso: string): string {
  return new Date(iso).toLocaleString(undefined, { weekday: "short", month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });
}
export function fmtDayLabel(d: Date): string {
  return d.toLocaleDateString(undefined, { weekday: "short", month: "short", day: "numeric" });
}
